import { FCC } from "@/types/common";
import { createContext, useContext, useMemo } from "react";

export type InitSetupType = {
  currentStep: number;
  checkFinishInitStep: React.MouseEventHandler<HTMLElement>;
  isLoading: boolean;
};

export const InitSetupContext = createContext<InitSetupType | undefined>(undefined);

export const InitSetupProvider: FCC = ({ children }) => {
  const currentStep = useMemo(() => {
    return 1;
  }, []);

  const checkFinishInitStep: React.MouseEventHandler<HTMLElement> = () => {};
  return <InitSetupContext.Provider value={{ currentStep, checkFinishInitStep, isLoading: false }}>{children}</InitSetupContext.Provider>;
};

export const useInitSetup = (): InitSetupType => {
  const context = useContext(InitSetupContext);
  if (!context) {
    throw new Error("useInitSetup must be used within a InitSetupProvider");
  }
  return context;
};
